import { Skeleton } from "@mui/material"
import { Stack } from "@mui/system"
import { CompleteRegistrationHeader } from "./IdCardSignupStepHeader"

export const IdCardSignupLoadingState = () => {
    return (
        <Stack gap="4rem">
            <CompleteRegistrationHeader />
            <Stack gap="1rem">
                <Skeleton variant="rectangular" animation="wave" width="65%" height={56} />
                <Skeleton variant="rectangular" animation="wave" width="65%" height={56} />
            </Stack>
        </Stack>
    )
}
